module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_9006.ce980bf7.png";